const eventNavbarMobile = (param) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `header_navigation_bar_button`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on ${param?.toLowerCase()}`,
    eventLabel: `${param?.toLowerCase()}`,
  });
};
export default eventNavbarMobile;
